<script>
    import { createEventDispatcher, onDestroy, onMount } from 'svelte';
    import Icon from './Icon.svelte';
    import { browser } from '$app/environment';

    export let shown = false;

    let className = '';
    export { className as class };

    let dispatch = createEventDispatcher();

    export const close = () => {
        shown = false;
        dispatch('close');
    };

    export const show = () => {
        shown = true;
        dispatch('show');
    };

    const handle_esc = (e) => {
        if (e.key === 'Escape') {
            close();
        }
    };

    $: if (shown && browser) {
        document.addEventListener('keydown', handle_esc);
    } else if (browser) {
        document.removeEventListener('keydown', handle_esc);
    }

    onDestroy(() => {
        if (shown && browser) document.removeEventListener('keydown', handle_esc);
    });
</script>

<div
    class="
        fixed top-0 left-0 w-full h-full z-10 overflow-y-auto
        {!shown ? 'hidden' : ''}
        {className}
    "
>
    <slot />

    <button on:click={close} class="fixed top-0 left-0 w-screen h-screen bg-black/70 -z-10">
        <Icon
            times
            class="absolute top-1 right-1 z-20 bg-black/50 rounded-full w-6 h-6"
        />
    </button>
</div>
